export default __webpack_public_path__ + "static/media/14.87ac558b.PNG";